/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 01/02/2022 09:07
 */

import { IEntity } from '../../interface/IEntity';
import { SelectableEntity } from '../entity/selectable-entity';
import { CommonUtils } from '../../tool/common-utils';

export class DataTableRow<T extends IEntity> extends SelectableEntity {
  public entity: T;
  public isDetailsOpened: boolean;
  public isLocked = false;
  public tableRowId = CommonUtils.uuid();

  constructor(entity: T) {
    super(entity.getId(), entity.getLabel());
    this.entity = entity;
  }
}
